
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import ContactFormSection from './components/ContactFormSection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function GetCashOfferPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Get Cash Offer for Your El Paso Property | TREX RE LLC"
        description="Get a fair cash offer for your El Paso house or land today. No obligations, no fees, close in as fast as 7 days. Fill out our simple form for your free cash offer."
        keywords="get cash offer El Paso, sell my house fast, cash for my property, free home valuation El Paso, TREX RE LLC cash offer"
        canonical="/get-cash-offer-for-my-property"
        schema={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Get Cash Offer",
          "description": "Request a free cash offer for your El Paso property"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <ContactFormSection />
      <Footer />
    </div>
  );
}
